import { Component, inject } from '@angular/core';
import { MobileCheckGuard } from './service/mobile-check.guard';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false,
    styleUrl: './app.component.scss'
})
export class AppComponent {
    mobileCheckGuard = inject(MobileCheckGuard);
    showmobile: boolean = false;

    constructor() {
        this.mobileCheckGuard.showmobile.subscribe((isMobile) => {
            this.showmobile = isMobile;
        });
    }
}

